import { Box, Text, HStack, Flex, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'
import BenefitMobile from './benefit-mobie'

const ProductCard05 = () => {
  const productData = {
    titleJP: '解毒湿气和毒素、除去湿气',
    titleEN: 'Detoxify dampness and toxins, remove dampness',
    subTitle:
      '调和脾胃湿热 / Regulate dampness and heat in the spleen and stomach',
    descJP: `祛湿丸具有祛湿清热、温阳化饮、利水消肿、健脾开胃、活血止痛的功效与作用，湿气重易殃及身体多个脏器，造成大大小小的健康状态，导致精神不振、注意力不集中等。祛除湿气能够有效地改善身体状态，促使精神饱满，对身体健康有一定好处。`,
    descEN: `Anti-Dampness Capsules effectively dispels dampness in our body, clears heat, warms vital energy and blood, induces diuresis to eliminate edema, strengthens the spleen, opens the stomach, activates circulation, and alleviates pain. Dampness can affect multiple organs, leading to a sub-healthy state characterized by mental instability and lack of concentration. By dispelling dampness, one can effectively enhance overall well-being and promote vitality, benefiting overall health.`,
    imageUrl:
      'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-5-1734075592409.png'
  }

  const benefitData = [
    {
      ratio: 610 / 694,
      imageUrl:
        'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-mobile-5-1733133947031.png',
      className: 'ml-[-6px]'
    }
  ]

  return (
    <Flex
      flexDir={{
        base: 'column',
        lg: 'row'
      }}
      justifyContent="space-between"
      pt={{
        base: '50px',
        lg: '105px'
      }}
      pb="80px"
      gap={5}
      id="anti-dampness"
    >
      <Box
        w={{
          base: '100%',
          lg: '50%'
        }}
        ml={{
          base: '0'
        }}
      >
        <AspectRatio ratio={1053 / 1471} w="100%">
          <Image src={productData.imageUrl} alt={productData.titleEN} fill />
        </AspectRatio>
      </Box>

      <Box
        w={{
          base: '100%',
          lg: '60%'
        }}
      >
        {/* Title and Subtitle */}
        <Box
          w="100%"
          maxW={{
            base: '100%',
            lg: '650px'
          }}
        >
          <Text textStyle="supplementProductCardTitleJP">
            {productData.titleJP}
          </Text>

          <Text textStyle="supplementProductCardTitleEN" mt={1}>
            {productData.titleEN}
          </Text>

          <Text
            textStyle="supplementProductCardSubTitle"
            bg="#9cb25a"
            w={{
              base: 'auto',
              lg: '100%',
              xl: 'max-content'
            }}
            mt={5}
            color="white"
            px={2}
            py={1}
          >
            {productData.subTitle}
          </Text>

          <Text textStyle="supplementProductCardDescJP" mt={5}>
            {productData.descJP}
          </Text>

          <Text textStyle="supplementProductCardDescEN" mt={5}>
            {productData.descEN}
          </Text>
        </Box>

        {/* Benefits */}
        <Box w="100%" mt={5}>
          <AspectRatio
            ratio={1644 / 250}
            w="100%"
            display={{
              base: 'none',
              md: 'block'
            }}
          >
            <Image
              src={
                'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item-5-1733133504841.png'
              }
              alt="traditional item"
              fill
            />
          </AspectRatio>

          <Box
            display={{
              base: 'block',
              md: 'none'
            }}
          >
            <BenefitMobile items={benefitData} isOne />
          </Box>
        </Box>

        {/* Buy Button */}
        <HStack
          justifyContent={{
            base: 'flex-start',
            md: 'flex-start'
          }}
          alignItems="center"
          gap={4}
          mt={5}
        >
          <Link href="https://habbit.sg/products/health-plus-kampo-anti-dampness-capsules-90s">
            <AspectRatio
              ratio={1537 / 864}
              w={{
                base: '120px',
                sm: '120px',
                md: '140px',
                lg: '160px',
                xl: '160px'
              }}
              _hover={{
                opacity: 0.7
              }}
              mt={3}
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/buy-now-btn-1714038035225.png'
                }
                alt="buy now btn"
                fill
              />
            </AspectRatio>
          </Link>

          <Box
            w={{
              base: '244px',
              xl: '244px'
            }}
            mt={2}
          >
            <AspectRatio ratio={123 / 36} w="100%">
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/item1-certificate-1730969831994.png'
                }
                alt="traditional item"
                fill
              />
            </AspectRatio>
          </Box>
        </HStack>
      </Box>
    </Flex>
  )
}

export default ProductCard05
